import { CheckCircle2, Circle, Copy } from "lucide-react";
import { copyText, relName } from "./helpers";

function CopyValue({ value, title, testid }) {
  return (
    <button type="button" onClick={() => copyText(value)} title={title || "Copia"} data-testid={testid}
      className="group inline-flex max-w-full items-start gap-1.5 rounded-md px-1.5 py-1 text-left font-mono text-xs text-slate-800 transition-colors hover:bg-sky-50">
      <span className="break-all">{value}</span><Copy size={12} className="mt-0.5 shrink-0 text-slate-400 group-hover:text-sky-600" />
    </button>
  );
}

export default function DnsRecordTable({ records, apex, testid }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-200" data-testid={testid}>
      <table className="w-full min-w-[640px] text-sm">
        <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
          <tr>{["", "Tipo", "Nome", "Valore", "A cosa serve"].map((x) => <th key={x} className="px-3 py-2 text-left font-medium">{x}</th>)}</tr>
        </thead>
        <tbody>
          {records.map((r) => (
            <tr key={r.key} className="border-t border-slate-100 align-top" data-testid={`${testid}-row-${r.key}`}>
              <td className="px-3 py-2.5" title={r.ok ? "Visto nei DNS pubblici" : "Non ancora visto"}>
                {r.ok ? <CheckCircle2 size={16} className="text-emerald-600" data-testid={`${testid}-ok-${r.key}`} /> : <Circle size={16} className="text-slate-300" />}
              </td>
              <td className="whitespace-nowrap px-3 py-2.5 font-mono text-xs">{r.type}</td>
              <td className="min-w-[120px] px-1.5 py-1.5"><CopyValue value={relName(r.name, apex)} title={`Nome completo: ${r.name}`} testid={`${testid}-name-${r.key}`} /></td>
              <td className="min-w-[210px] px-1.5 py-1.5"><CopyValue value={r.value} testid={`${testid}-value-${r.key}`} /></td>
              <td className="min-w-[200px] px-3 py-2.5 text-xs text-slate-500">{r.purpose}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
